export default "__VITE_ASSET__Dl6kHXUN__"